var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"delete-answer__option"},[_c('div',{staticClass:"delete-answer__button"},[_c('AgreeSVG',_vm._g({staticClass:"delete-answer__button_green"},_vm.$listeners))],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }